/**** AUTHENTICATE USER INFO HERE ****/
import CryptoJS from "crypto-js";
import { defineStore } from "pinia";

const SECRET_KEY = import.meta.env.VITE_APP_SECRET_KEY;
function tryParseJson(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return undefined;
  }
}

const storage = {
  getItem: (key) => {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return null;

    const plain = tryParseJson(raw);
    if (plain !== undefined) {
      // Migrate to encrypted form (best-effort)
      try {
        const encrypted = CryptoJS.AES.encrypt(
          JSON.stringify(plain),
          SECRET_KEY
        ).toString();
        localStorage.setItem(key, encrypted);
      } catch (e) {
        console.warn("Migration encrypt failed:", e);
      }
      return plain;
    }

    try {
      const decrypted = CryptoJS.AES.decrypt(raw, SECRET_KEY).toString(
        CryptoJS.enc.Utf8
      );
      if (!decrypted) return null;
      const parsed = JSON.parse(decrypted);
      return parsed;
    } catch (e) {
      console.warn("Decrypt failed:", e);
      return null;
    }
  },

  setItem: (key, value) => {
    try {
      const stringified = JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(
        stringified,
        SECRET_KEY
      ).toString();
      localStorage.setItem(key, encrypted);
    } catch (e) {
      console.error("setItem encryption failed:", e);
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {}
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};
const useAuth = defineStore(
  "auth",
  () => {
    const getToken = ref(0);

    const setToken = (token) => {
      getToken.value = token;
      // localStorage.setItem('token',token);
    };

    const removeToken = () => {
      getToken.value = 0;
      // localStorage.removeItem('token');
    };

    return {
      getToken,
      setToken,
      removeToken,
    };
  },
  {
    persist: {
      key: "token",
      storage,
    },
  }
);

export default useAuth;
